import type { FormMessage } from '../app.d';
import { toastCustom } from './toasts';
import * as flashModule from 'sveltekit-flash-message/client';

export const handleFormMessages = (message: FormMessage) => {
  toastCustom({
    position: 'bottom-center',
    title: message.title,
    description: message.description,
    positive: message.status === 'success',
    negative: message.status === 'error',
    warning: message.status === 'warning',
  });
};

const multipleSubmits: 'prevent' | 'allow' | 'abort' = 'prevent';
export const superFormOptions = {
  resetForm: true,
  multipleSubmits,
  flashMessage: {
    module: flashModule,
  },
  syncFlashMessage: true,
  warnings: {
    duplicateId: false,
    noValidationAndConstraints: false,
  },
};
